import { getBasePathWithoutTrailingSlash } from "./basePath";

/** API paths that must work without a dashboard session (registration / marketing). */
const PUBLIC_API_PATH_FRAGMENTS = [
  "/auth/register",
  "/auth/registerindividual",
  "/auth/verifycode",
  "/auth/resendcode",
  "/auth/signin",
  "/auth/login",
  "/auth/refresh",
  "/auth/completecompanyregistration",
  "/package/getall",
  "/marketing/",
  "/country",
  "/lookup/getbyparentcode",
  "/lookup/bycode",
  "/lookup/createdraft",
  "/user/getregisterdata",
  "/user/createcompanyuser",
  "/payment/createsession",
  "/payment/processresult",
];

export function isPublicApiUrl(url: string): boolean {
  const u = (url || "").toLowerCase();
  return PUBLIC_API_PATH_FRAGMENTS.some((fragment) => u.includes(fragment));
}

/** Pathname relative to router basename (e.g. /UAT/register → /register). */
export function getAppPathname(): string {
  if (typeof window === "undefined") return "";
  const base = getBasePathWithoutTrailingSlash().toLowerCase();
  let path = window.location.pathname.toLowerCase();
  if (base && (path === base || path.startsWith(`${base}/`))) {
    path = path.slice(base.length) || "/";
  }
  if (!path.startsWith("/")) {
    path = `/${path}`;
  }
  return path;
}

export function isRegistrationPage(): boolean {
  const path = getAppPathname();
  return path === "/register" || path.startsWith("/register/");
}

/** True while completing signup — do not wipe an existing dashboard session. */
export function mayClearAuthSession(): boolean {
  if (!isRegistrationPage()) return true;
  return sessionStorage.getItem("__manual_logout__") === "true";
}

/** Do not attach JWT — avoids expired dashboard tokens breaking onboarding. */
export function shouldOmitAuthForRequest(url: string): boolean {
  return isPublicApiUrl(url) || isRegistrationPage();
}

/** Do not clear session / show "token expired" on failed registration API calls. */
export function shouldSkipSessionClearOn401(url: string): boolean {
  return isPublicApiUrl(url) || isRegistrationPage();
}
